var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowMobileTimeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 9,
  viewBox: "0 0 56 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.830078 4C0.553936 4 0.330078 4.22386 0.330078 4.5C0.330078 4.77614 0.553936 5 0.830078 5V4.5V4ZM55.8443 4.85355C56.0395 4.65829 56.0395 4.34171 55.8443 4.14645L52.6623 0.964466C52.467 0.769204 52.1505 0.769204 51.9552 0.964466C51.7599 1.15973 51.7599 1.47631 51.9552 1.67157L54.7836 4.5L51.9552 7.32843C51.7599 7.52369 51.7599 7.84027 51.9552 8.03553C52.1505 8.2308 52.467 8.2308 52.6623 8.03553L55.8443 4.85355ZM0.830078 4.5V5H55.4907V4.5V4H0.830078V4.5Z",
  fill: "#2C2D2E"
})));
export { SvgArrowMobileTimeline as ReactComponent };